import styled from 'styled-components';
import { ColorPicker, Input as antdInput, Tree, Dropdown } from 'antd';
import Input from '../../components/common/Input';
const { Search } = antdInput;
const cursorStyle = 'crosshair';
const { DirectoryTree } = Tree;
export const EditorWrapper = styled.div `
  height: 100vh;
  width: 100vw;
  overflow: hidden;
`;
export const EditorBackgroundGradient = styled.div `
  position: fixed;
  width: 252px;
  pointer-events: none;
  top: 0;
  bottom: 0;
  opacity: 0.7;
  backdrop-filter: saturate(180%) blur(20px);
  z-index: 4;

  ${({ dir }) => dir === 'left' &&
    ` 
    left: 0;
    background: linear-gradient(to right, rgb(245, 245, 245) 0%, transparent 100%);
  `}

  ${({ dir }) => dir === 'right' &&
    ` 
    right: 0;
    background: linear-gradient(to left, rgb(245 245 245) 0%, transparent 100%);
  `}
`;
export const Editorcontainer = styled.div `
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  cursor: default;
`;
export const EditorMap = styled.div `
  height: 100%;
  width: 100%;
  position: relative;
  z-index: 2;
  // cursor : ${cursorStyle}!important;
  cursor: ${({ tool }) => {
    switch (tool) {
        case 'select':
            return 'pointer';
        case null:
            return 'grab';
        case 'wall':
            return 'crosshair';
        case 'innerWall':
            return 'crosshair';
        case 'route':
            return 'crosshair';
        case 'rectangle':
            return 'crosshair';
        case 'circle':
            return 'crosshair';
        case 'custom':
            return 'crosshair';
        case 'undo':
            return 'pointer';
        case 'redo':
            return 'pointer';
        case 'modify':
            return 'crosshair';
        default:
            return 'default';
    }
}} !important;
`;
export const EditorcontainerTools = styled.div `
  position: relative;
  flex-grow: 1;
  text-align: center;
  cursor: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgZmlsdGVyPSJ1cmwoI2ZpbHRlcjBfZF8xMDIzOV8xNjEzNTEpIj4KPHBhdGggZD0iTTE0LjUgMjNMMTIgMTBMMjMgMTYuNUwxNy41IDE4TDE0LjUgMjNaIiBmaWxsPSIjMDEwMTAxIi8+CjxwYXRoIGQ9Ik0xNC4wMDkgMjMuMDk0NEwxNC4yNTU5IDI0LjM3ODZMMTQuOTI4NyAyMy4yNTcyTDE3LjgyNTQgMTguNDI5NUwyMy4xMzE2IDE2Ljk4MjRMMjQuMjcyNiAxNi42NzEyTDIzLjI1NDQgMTYuMDY5NUwxMi4yNTQ0IDkuNTY5NTRMMTEuMjk5NiA5LjAwNTMzTDExLjUwOSAxMC4wOTQ0TDE0LjAwOSAyMy4wOTQ0WiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIvPgo8L2c+CjxkZWZzPgo8ZmlsdGVyIGlkPSJmaWx0ZXIwX2RfMTAyMzlfMTYxMzUxIiB4PSI3LjU5NzY2IiB5PSI2LjAxMDc0IiB3aWR0aD0iMjAuOTQ5MiIgaGVpZ2h0PSIyMy43NDY2IiBmaWx0ZXJVbml0cz0idXNlclNwYWNlT25Vc2UiIGNvbG9yLWludGVycG9sYXRpb24tZmlsdGVycz0ic1JHQiI+CjxmZUZsb29kIGZsb29kLW9wYWNpdHk9IjAiIHJlc3VsdD0iQmFja2dyb3VuZEltYWdlRml4Ii8+CjxmZUNvbG9yTWF0cml4IGluPSJTb3VyY2VBbHBoYSIgdHlwZT0ibWF0cml4IiB2YWx1ZXM9IjAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDEyNyAwIiByZXN1bHQ9ImhhcmRBbHBoYSIvPgo8ZmVPZmZzZXQgZHk9IjEiLz4KPGZlR2F1c3NpYW5CbHVyIHN0ZERldmlhdGlvbj0iMS41Ii8+CjxmZUNvbG9yTWF0cml4IHR5cGU9Im1hdHJpeCIgdmFsdWVzPSIwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwLjM1IDAiLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbjI9IkJhY2tncm91bmRJbWFnZUZpeCIgcmVzdWx0PSJlZmZlY3QxX2Ryb3BTaGFkb3dfMTAyMzlfMTYxMzUxIi8+CjxmZUJsZW5kIG1vZGU9Im5vcm1hbCIgaW49IlNvdXJjZUdyYXBoaWMiIGluMj0iZWZmZWN0MV9kcm9wU2hhZG93XzEwMjM5XzE2MTM1MSIgcmVzdWx0PSJzaGFwZSIvPgo8L2ZpbHRlcj4KPC9kZWZzPgo8L3N2Zz4K)
      11 8,
    auto !important;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
`;
export const EditorHeader = styled.div `
  padding: 5px 8px;
  width: 100%;
  transition: all 300ms ease-in-out;
  display: flex;
  z-index: 2;
  background-color: #fff;
  gap: calc(calc(5 * 1px) * 3);
  gap: 8px;
  height: 60px;
  pointer-events: none;
  justify-content: space-between;
  border-bottom: 1px solid hsla(0, 0%, 0%, 0.07);
`;
export const HeaderMenuItem = styled.div `
  width: 100%;
  display: flex;
  justify-content: space-between;
  min-width: 150px;
  align-items: center;
  position: relative;
  box-sizing: border-box;
  white-space: nowrap;
  font-size: 14px;
  line-height: calc(14px + 4px);
  gap: calc(5 * 1px);
  padding: calc(calc(calc(5 * 1px) * 2) - 2px) calc(calc(calc(5 * 1px) * 3) - 2px);
  min-height: calc(calc(14px + 4px) + calc(calc(calc(5 * 1px) * 2) - 2px) * 2);
  border-radius: calc(15px - 2px);
  color: hsla(0, 0%, 33.33%, 1) !important;
  font-weight: 500;
`;
export const EditorContent = styled.div `
  flex: 1;
  overflow: hidden;
  background-color: hsl(0, 0%, 95%, 1);
  position: relative;
  height: calc(100dvh - 60px);
`;
export const EditorToolArea = styled.div `
  position: absolute;
  padding: 8px;
  padding-top: 0;
  overflow: hidden;
  display: grid;
  align-content: stretch;
  grid-template-columns: 0 1fr fit-content(0);
  grid-template-rows: fit-content(0) 1fr fit-content(0);
  grid-template-areas:
    'asideLeft underHeader underHeader'
    'asideLeft center asideRight'
    'asideLeft footer footer';
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 4;
  pointer-events: none;
`;
export const HeaderMenuItemDropdown = styled.div `
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  box-sizing: border-box;
  white-space: nowrap;
  visibility: visible;
  gap: 8px;
  margin: 0px;
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
`;
export const HeaderMenuItemDropdownAction = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  padding: 0 2px;
  border-radius: 4px;
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
`;
export const EditorHeaderLeft = styled.div `
  flex-shrink: 1;
  pointer-events: all;
`;
export const EditorHeaderRight = styled.div `
  display: flex;
  align-items: center;
  pointer-events: auto;
`;
export const EditorHeaderSection = styled.div `
  flex-shrink: 0;
  pointer-events: all;
  display: flex;
  align-items: center;
  justify-content: center;

  button.sq {
    min-width: 36px;
    padding: 4px 0;
  }
`;
export const EditorTools = styled.div `
  all: unset;
  display: flex;
  box-sizing: border-box;
  align-items: center;
  max-width: 100%;
  pointer-events: all;
  gap: 8px;
  /* background-color: #ffffff;
  box-shadow: 0 4px 16px #05003812; */
  border-radius: 4px;
  padding: 2px;

  ${({ orientation }) => orientation === 'horizontal' && 'height:48px'}
`;
export const EditorHeaderItem = styled.div `
  color: #222428;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
  flex-shrink: 0;
  margin-top: 0px;
  /* padding-left: 8px;
  padding-right: 8px; */
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  border-radius: 4px;
  font-size: 14px;
  line-height: calc(14px + 4px);
  gap: calc(5 * 1px);
  min-height: calc(calc(14px + 4px) + calc(calc(calc(5 * 1px) * 2) - 2px) * 2);

  ${({ hasBorder }) => hasBorder &&
    `
   border:2px solid hsl(0deg 0% 0% / 16%);
    color: hsla(0, 0%, 33.33%, 1);
        border-radius: 15px;
    background-color: hsla(0, 0%, 100%, 1);
  `}
`;
export const HeaderLabel = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  line-height: 14px;
  gap: 4px;
  min-height: 46px;
`;
export const LeftPanel = styled.div `
  /* ${({ position }) => position === 'right'
    ? `
        right: 12px;
        bottom :12px;
        top:64px;
      `
    : position === 'top'
        ? `
       top:64px;
       right:12px;
       left:12px;
      `
        : position === 'bottom'
            ? `
        bottom :12px;
         right:12px;
       left:12px;
      `
            : `
        bottom :12px;
        left: 12px;
        top:64px;
      `}

  ${({ placement, position }) => placement === 'center' &&
    `
    ${position === 'right'
        ? 'top: 50%; right: 12px; transform: translateY(-50%); '
        : position === 'top'
            ? 'left: 50%; top: 12px; transform: translateX(-50%);'
            : position === 'bottom'
                ? 'left: 50%; bottom: 12px; transform: translateX(-50%);'
                : 'top: 50%; left: 12px; transform: translateY(-50%);'}
  `}


  position: absolute;
  z-index: 9;
  pointer-events: none;

  transform: ${({ isOpen, position, placement }) => {
    const translateX = (val) => `translateX(${val}%)`;
    const translateY = (val) => `translateY(${val}%)`;
    const getTransform = (x, y) => `${translateY(y)} ${translateX(x)}`;
    if (placement === 'center') {
        if (!isOpen) {
            switch (position) {
                case 'top':
                    return getTransform(-50, -125);
                case 'bottom':
                    return getTransform(-50, 125);
                case 'right':
                    return getTransform(125, -50);
                default:
                    return getTransform(-125, -50);
            }
        }
        else {
            switch (position) {
                case 'top':
                    return getTransform(-50, -125);
                case 'bottom':
                    return getTransform(-50, 0);
                case 'right':
                    return getTransform(0, -50);
                default:
                    return getTransform(-125, -50);
            }
        }
    }
    else {
        if (!isOpen) {
            switch (position) {
                case 'top':
                    return translateY(-125);
                case 'bottom':
                    return translateY(125);
                case 'right':
                    return translateX(125);
                default:
                    return translateX(-125);
            }
        }
        else {
            return getTransform(0, 0);
        }
    }
}};

  transition: transform 0.5s cubic-bezier(0.82, 0.085, 0.395, 0.895); */
  grid-area: ${({ position }) => (position === 'right' ? 'asideRight' : 'asideLeft')};
  height: 100%;
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  padding-block: 8px;
  box-sizing: border-box;
  --flex-prop: ${({ fill }) => (fill ? '0 0 50%' : 1)};
  --flex-justify: ${({ center }) => (center ? 'center' : 'flex-start')};
`;
export const FloatingPanel = styled.div `
  ${({ position }) => position === 'right'
    ? `
        right: 12px;
        bottom :12px;
        top:64px;
      `
    : position === 'top'
        ? `
       top:64px;
       right:12px;
       left:12px;
      `
        : position === 'bottom'
            ? `
        bottom :12px;
         right:12px;
       left:12px;
      `
            : `
        bottom :12px;
        left: 12px;
        top:64px;
      `}

  ${({ placement, position }) => placement === 'center' &&
    `
    ${position === 'right'
        ? 'top: 50%; right: 12px; transform: translateY(-50%); '
        : position === 'top'
            ? 'left: 50%; top: 12px; transform: translateX(-50%);'
            : position === 'bottom'
                ? 'left: 50%; bottom: 12px; transform: translateX(-50%);'
                : 'top: 50%; left: 12px; transform: translateY(-50%);'}
  `}


  position: fixed;
  z-index: 9;
  pointer-events: none;

  transform: ${({ isOpen, position, placement }) => {
    const translateX = (val) => `translateX(${val}%)`;
    const translateY = (val) => `translateY(${val}%)`;
    const getTransform = (x, y) => `${translateY(y)} ${translateX(x)}`;
    if (placement === 'center') {
        if (!isOpen) {
            switch (position) {
                case 'top':
                    return getTransform(-50, -125);
                case 'bottom':
                    return getTransform(-50, 125);
                case 'right':
                    return getTransform(125, -50);
                default:
                    return getTransform(-125, -50);
            }
        }
        else {
            switch (position) {
                case 'top':
                    return getTransform(-50, -125);
                case 'bottom':
                    return getTransform(-50, 0);
                case 'right':
                    return getTransform(0, -50);
                default:
                    return getTransform(-125, -50);
            }
        }
    }
    else {
        if (!isOpen) {
            switch (position) {
                case 'top':
                    return translateY(-125);
                case 'bottom':
                    return translateY(125);
                case 'right':
                    return translateX(125);
                default:
                    return translateX(-125);
            }
        }
        else {
            return getTransform(0, 0);
        }
    }
}};
`;
export const LeftPanelContainer = styled.div `
  pointer-events: all;
  user-select: none;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  cursor: default;
  justify-content: var(--flex-justify, flex-start);
  gap: 0.8rem;
`;
export const LeftPanelCard = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  scrollbar-width: none;
  pointer-events: all;
  overflow-x: hidden;
  border-right: none;
  scroll-behavior: smooth;
  border-radius: 0.8125rem;
  flex: var(--flex-prop, 1);

  border-radius: 15px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.07), 0 15px 35px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
  background-color: hsla(0, 0%, 100%, 1);
`;
export const LeftPanelCardHead = styled.div `
  text-align: left;
  padding: 16px;
  border-bottom: 2px solid rgb(0 0 0 / 9%);
  margin-bottom: 16px;
  padding: calc(5px * 3) calc(5px * 4);
  h3 {
    display: block;
    border: 0;
    background: transparent;
    width: 100%;
    font-size: calc(14px + 4px);
    line-height: calc(14px + 6px);
    font-weight: 600;
    text-align: left;
    cursor: pointer;
    margin: 0;
  }

  h4 {
    font-size: 24px;
    font-weight: 900;
    letter-spacing: -0.2px;
    flex: 1;
    margin: 0;
  }
`;
export const RightPanel = styled.div `
  top: 12px;
  right: 12px;
  bottom: 12px;
  position: absolute;
  z-index: 6;
  pointer-events: none;
  transform: ${({ isOpen }) => (isOpen ? 'translateX(0)' : 'translateX(+125%)')};
  transition: transform 0.5s cubic-bezier(0.82, 0.085, 0.395, 0.895);
  width: fit-content;
  max-width: 320px;
  height: fit-content;
  /* background-color: red; */
`;
export const RightPanelContainer = styled.div `
  pointer-events: all;
  user-select: none;
  display: flex;
  flex-direction: column;
  height: 100%;
  cursor: default;
  gap: 0.8rem;
`;
export const RightPanelCard = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  scrollbar-width: none;
  pointer-events: all;
  box-shadow: 0px 6px 20px rgba(25, 25, 26, 0.06), 0px 2px 12px rgba(25, 25, 26, 0.04);
  overflow-x: hidden;
  border-right: none;
  scroll-behavior: smooth;
  border-radius: 0.8125rem;

  border: 1px solid rgba(18, 17, 42, 0.07);
`;
export const RightPanelCardHead = styled.div `
  text-align: left;
  padding: 16px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray300};
  margin-bottom: 16px;
  h3 {
    font-size: 30px;
    font-weight: 900;
    letter-spacing: -0.2px;
    flex: 1;
    margin: 0;
  }

  h4 {
    font-size: 24px;
    font-weight: 900;
    letter-spacing: -0.2px;
    flex: 1;
    margin: 0;
  }
`;
export const RightPanelCardBody = styled.div `
  position: relative;
  overflow-y: auto;
  flex-grow: 1;
`;
export const RightPanelCardFooter = styled.div `
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 0.8rem;
  flex-direction: row;
  padding: 0 16px;
  border-top: 1px solid ${({ theme }) => theme.colors.gray300};
`;
export const PanelAction = styled.div `
  width: 100%;
  text-align: right;
  margin-bottom: 8px;
`;
export const PanelSearch = styled(Input) `
  .bc-input-prefix {
    color: inherit;
    margin-inline-end: 6px;
  }
`;
export const LeftPanelCardBody = styled.div `
  position: relative;
  overflow-y: auto;
  flex-grow: 1;
  text-align: start;
`;
export const LeftPanelCardFooter = styled.div `
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 0.8rem;
  flex-direction: row;
  padding: 0 16px;
  border-top: 1px solid ${({ theme }) => theme.colors.gray300};
`;
export const PanelBody = styled.div `
  overflow: hidden;
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  word-break: keep-all;
`;
export const PanelHeader = styled.div `
  z-index: 2;
  border-bottom: 1px solid #e6e6e6;
  padding-left: 0.5rem;
  gap: 0.5rem;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  height: 40px;
`;
export const PanelHeaderTitle = styled.div `
  display: flex;
  align-items: flex-start;
  flex-grow: 1;
  gap: 0.5rem;
  display: flex;
  padding-left: 8px;
  min-width: 0px;
  flex: 1 1 0%;
  color: #000000e5;
  padding-right: 0.5rem;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.00344rem;
  line-height: 1rem;
`;
export const PanelHeaderAction = styled.div `
  margin-right: 8px;
  position: relative;
  justify-content: flex-end;
  align-items: center;
  display: flex;
`;
export const PanelObject = styled.div `
  margin: 0;
  padding: 0;
  list-style: none;
  overflow: hidden;
  overflow-y: auto;
  font-size: 13px;
  .bc-tree {
    --bc-tree-title-height: 26px;
    --bc-tree-directory-node-selected-bg: #ddffe7;
    --bc-tree-directory-node-selected-color: #0d0d0d;
  }
`;
export const LayersTree = styled(Tree) `
  /* font-size: 14px;
  --bc-tree-title-height: 32px;

  .bc-tree-draggable-icon,.bc-tree-indent {
    display: none;
  }
  .bc-tree-node-content-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .bc-tree-treenode:before {
    inset-inline-start: 12px !important;
    inset-inline-end: 8px !important;
    border-radius: 6px !important;
  }
  .bc-tree-switcher {
    opacity: 0;
    margin-left: 16px;
    width: 11px;
  }
  .bc-tree-treenode:hover {
    .bc-tree-switcher {
      opacity: 0.5;
    }
  }
  .bc-tree-switcher:hover::before {
    background: transparent !important;
  }
  .bc-tree-node-content-wrapper {
    padding: 0;
  }
  .bc-tree-title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  } */
`;
export const PanelObjectRow = styled.li `
  list-style: none;
  font-size: inherit;
  font-weight: normal;
`;
export const PanelObjectRowChild = styled.ul `
  list-style: none;
  padding-left: 20px;
`;
export const PanelObjectRowContainer = styled.div `
  display: flex;
  align-items: center;
  height: 100%;
`;
export const PanelObjectRowIndent = styled.span `
  width: 16px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  flex-shrink: 0;
  display: flex;
  position: relative;
  height: 100%;
  flex-shrink: 0;
  svg {
    opacity: 0;
  }
`;
export const PanelObjectRowLayerIcon = styled.span `
  width: 16px;
  display: flex;
  justify-content: center;
  flex-shrink: 0;
  height: 100%;
  align-items: center;
  position: relative;
  color: rgba(0, 0, 0, 0.9);
`;
export const PanelObjectRowLayerText = styled.span `
  display: flex;
  line-height: 30px;
  height: 30px;
  padding: 0 8px;
  width: calc(100% - 16px);
  flex-shrink: 1;
  white-space: pre;
  text-align: left;
  font-size: 11px;
  /* font-weight: 500; */
  font-family: inherit;
  overflow: hidden;
  text-overflow: ellipsis;
  align-items: center;
  justify-content: flex-start;
  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-grow: 5;
    max-width: -moz-fit-content;
    max-width: fit-content;
  }
`;
export const ToolBar = styled.div `
  /* position: fixed;
  display: flex;
  justify-content: center;
  left: 0;
  right: 0;
  bottom: 12px;
  pointer-events: none;
 */
  grid-area: footer;
  display: flex;
  box-sizing: border-box;
  margin-bottom: 12px;
  transition: all ease-in-out 0.2s;
  transform: translateY(0);
  z-index: 8;

  ${({ hide }) => hide &&
    `
    transform: translateY(130%);
  `}
`;
export const EditorMapController = styled.div `
  grid-area: underHeader;
  padding-top: 8px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  box-sizing: border-box;
`;
export const EditorMapControllerInner = styled.div `
  display: flex;
  align-items: center;
  justify-content: flex-end;
  pointer-events: all;
  border-radius: 15px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.07), 0 15px 35px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
  background-color: hsla(0, 0%, 100%, 1);
  gap: 12px;
  padding: 8px;
`;
export const SearchArea = styled.div `
  position: relative;
  svg {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    z-index: 4;
    color: ${({ theme }) => theme.colors.primary};
  }
  input {
    /* background-color: hsla(
      0,
      0%,
      100%,
      1
    );
    color: hsla(
      0,
      0%,
      33.33%,
      1
    );
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    transition: background-color 0.1s linear;
    border: 2px solid hsl(0deg 0% 0% / 16%);
    border-radius: calc(15px - 2px);
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
    padding: calc(calc(5px * 2) - 2px)
      calc(calc(5px * 3) - 2px);
    min-height: calc(
      18px + calc(calc(5px * 2) - 2px) *
        2
    );
    font-size: 14px;
    line-height: 18px;
    box-sizing: border-box; */
    padding-right: 10px;
  }
`;
export const ToolBarInner = styled.div `
  /* display: flex;
  height: 100%;
  box-sizing: border-box;
  flex-flow: row wrap;
  align-content: flex-start;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  transition: height 0.2s linear, top 0.2s linear, width ease-in-out 0.3s;
  z-index: 90;
  position: relative;
  
  gap: 8px;
  flex-flow: row nowrap;
  flex-direction: row;
  height: 48px; */
  position: relative;
  pointer-events: all;
  display: flex;
  pointer-events: none;
  width: 100%;
  justify-content: center;
`;
export const Tools = styled.div `
  border-radius: 15px;
  display: flex;
  position: relative;
  pointer-events: auto;
  align-items: center;
  background-color: #ffffff;
  height: 48px;
  overflow: hidden;
  width: -moz-fit-content;
  width: fit-content;
  pointer-events: auto;
  gap: 0.8rem;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.07), 0 15px 35px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
  padding: 0 0.5rem;
  z-index: 1;
  box-sizing: border-box;
  * {
    transition: all ease-in-out 0.2s;
  }
`;
export const SingleTool = styled.div `
  --color-icon: ${({ selected }) => (selected ? '#ffffff' : '#222428')};
  --background-color: ${({ selected, theme }) => (selected ? theme.colors.primary : 'transparent')};
  --hover-color: ${({ selected, theme }) => (!selected ? 'rgba(0, 0, 0, 0.06)' : theme.colors.primary)};
  /*--border-radius: 0.3125rem;
  outline: 2px solid transparent;
  display: flex;
  align-items: center;
  gap: 0;
  align-self: center;
  box-sizing: border-box; */

  outline: 2px solid transparent;
  display: flex;
  align-items: center;
  gap: 0;
  align-self: center;
  box-sizing: border-box;
  outline: none;
  box-shadow: none;
  background: transparent;
  box-sizing: border-box;
  cursor: pointer;
  user-select: none;
  font: unset;
  color: var(--color-icon);
  border: none;
`;
export const ToolIcon = styled.div `
  box-sizing: border-box;
  width: 32px;
  height: 32px;
  padding: 0.25rem;
  border-radius: 8px;
  background-color: var(--background-color);
  color: var(--color-icon);
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background-color: var(--hover-color);
  }
`;
export const ToolDropDown = styled.div `
  align-self: stretch;
  padding: 0.25rem 0;
  width: 16px;
  border-radius: 8px;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover,
  &.bc-dropdown-open {
    background-color: rgba(0, 0, 0, 0.06);
  }
  &.bc-dropdown-open {
    svg {
      transform: rotate(-180deg);
    }
  }
`;
export const ToolMenuItem = styled.div `
  font-weight: 400;
  display: flex;
  align-items: center;
  line-height: 24px;
  cursor: default;
  -webkit-text-decoration: none;
  text-decoration: none;
  text-align: left;
  white-space: nowrap;
  /* justify-content: space-between; */
  /* font-size: 14px; */
  gap: 0.5rem;
  font-weight: 600;
  padding-left: 20px;
  position: relative;
  & > svg {
    fill: red;
    position: absolute;
    left: -5px;
    top: 50%;
    transform: translateY(-50%);
  }
  svg {
    flex: 0 0 16px;
  }
  span {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex: 1;
    gap: 5px;
    min-width: 100px;
    /* flex:  0 0 150px; */
  }

  em {
    flex: 0 0 24px;
    opacity: 0.5;
  }
`;
export const RightFooter = styled.div `
  grid-area: canvasControls;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: end;
  width: 100%;
  min-width: 340px;
`;
export const RightFooterInner = styled.div `
  background-color: #ffffff;
  box-shadow: 0 4px 16px #05003812;
  border-radius: 4px;
  padding: 0 4px;
  pointer-events: all;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: column;
`;
export const RightFooterItem = styled.div `
  /* height: 48px; */
  padding: 12px 4px;
  display: flex;
  box-sizing: border-box;
  align-items: center;
  max-width: 100%;
  gap: 4px;
`;
export const ColorPickerInput = styled(ColorPicker) `
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  --bc-color-bg-elevated: hsla(0, 0%, 0%, 0.07);
  --bc-color-border: transparent;
  padding: 10px 15px !important;
  border-radius: 15px;
  .bc-color-picker-clear,
  .bc-color-picker-color-block {
    border-radius: 8px;
    box-shadow: 0 1px 3px 0 #00000012;
    background-color: hsla(0, 0%, 100%, 1);
  }
  &:hover {
    box-shadow: inset 0 0 0 2px hsla(129, 60%, 50%, 1);
  }
`;
export const FilterMenuSec = styled.div `
  .bc-checkbox-group {
    gap: 5px;
  }
  .bc-checkbox-wrapper {
    background-color: rgba(0, 0, 0, 0.07);
    padding: 2px 3px;
    border-radius: 8px;
    border: 1px solid transparent;

    &-checked {
      border-color: ${({ theme }) => theme.colors.primary};
    }
  }
`;
export const InnerFormSection = styled.div `
  /* display: flex;
  flex-direction: column;
  gap: 0.5rem; */
  padding: 16px;
  background-color: rgba(0, 0, 0, 0.07);
  border-radius: 0.8125rem;

  .bc-list-item {
    padding: 0;
    border-block-end: none;
    background-color: #ffffff;
    padding: 5px 10px;
    margin-bottom: 10px;
    border-radius: 0.3125rem;
    font-size: 13px;
    --bc-font-size: 13px;
    --bc-font-weight: 600;
    --bc-line-height: 1.3;
    h4 {
      font-weight: 600;
      font-size: 13px;
      margin-bottom: 1px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .bc-list-item-meta-description {
      --bc-list-description-font-size: 12px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`;
export const BgWrapperEditorInput = styled.div `
  width: 100%;
  background-color: hsla(0, 0%, 0%, 0.07);
  padding: calc(calc(5 * 1px) * 2) calc(calc(5 * 1px) * 3);
  border-radius: 6px;

  font-size: 14px;
  line-height: calc(14px + 4px);
  border-radius: 15px;
  color: hsla(0, 0%, 33.33%, 1) !important;
`;
export const CompactFormEditor = styled.div `
  & > :first-child {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;

    &:not(:focus-within) {
      border-bottom: 1px solid ${({ theme }) => theme.colors.gray400};
    }
  }
  & > :last-child {
    --bc-border-radius: 0 0 6px 6px;
  }
`;
export const FloorDropdown = styled(Dropdown) `
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 180px;
  gap: 10px;
  cursor: pointer;
  padding: 7px 8px 7px 12px;
  background: hsla(0, 0%, 0%, 0.07);
  background-color: hsla(0, 0%, 0%, 0.07);
 
  border-radius: 12px;
  span {
    overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  text-align: left;
  }
  svg {
    flex: 0 0 20px;
  }
  /* .bc-btn {
    
} */
`;
